import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ArmazemModel } from 'app/model/endereco/armazem.model';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';

@Injectable()
export class ArmazemService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient:HttpClient) { }

  getPageArmazem(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-armazem?page=${page}&size=${size}`, this.httpOptions);
  }

  getArmazem(): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-armazem', this.httpOptions);
  }

  postArmazem(armazem: ArmazemModel): Observable<ArmazemModel> {
    return this.httpClient.post<ArmazemModel>(this.apiURL + '/new/adicionar-armazem', armazem, this.httpOptions);
  }

  putArmazem(armazem: ArmazemModel): Observable<ArmazemModel> {
    return this.httpClient.put<ArmazemModel>(this.apiURL + '/edit/editar-armazem', armazem, this.httpOptions);
  }


  deleteArmazem(id: any) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/apagar-armazem/'.concat(id), { headers, responseType: 'text'});
  }

  listarArmazensUsuario() {
    return this.httpClient.get(this.apiURL + '/listar-armazens-por-clientes', this.httpOptions);
  }


}



// WEBPACK FOOTER //
// /app/src/app/service/endereco/armazem.service.ts